"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VarStmt = exports.BreakStmt = exports.ContinueStmt = exports.WhileStmt = exports.ReturnStmt = exports.PrintStmt = exports.IfStmt = exports.FunctionStmt = exports.ExpressionStmt = exports.ClassStmt = exports.BlockStmt = exports.VariableExpr = exports.UnaryExpr = exports.TernaryExpr = exports.ThisExpr = exports.SuperExpr = exports.SetExpr = exports.LogicalExpr = exports.LiteralExpr = exports.GroupingExpr = exports.GetExpr = exports.FunctionExpr = exports.CallExpr = exports.BinaryExpr = exports.AssignExpr = void 0;
class AssignExpr {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.AssignExpr = AssignExpr;
class BinaryExpr {
    constructor(left, operator, right) {
        this.left = left;
        this.operator = operator;
        this.right = right;
    }
}
exports.BinaryExpr = BinaryExpr;
class CallExpr {
    constructor(callee, paren, args) {
        this.callee = callee;
        this.paren = paren;
        this.args = args;
    }
}
exports.CallExpr = CallExpr;
class FunctionExpr {
    constructor(name, params, body) {
        this.name = name;
        this.params = params;
        this.body = body;
    }
}
exports.FunctionExpr = FunctionExpr;
class GetExpr {
    constructor(object, name) {
        this.object = object;
        this.name = name;
    }
}
exports.GetExpr = GetExpr;
class GroupingExpr {
    constructor(expression) {
        this.expression = expression;
    }
}
exports.GroupingExpr = GroupingExpr;
class LiteralExpr {
    constructor(value) {
        this.value = value;
    }
}
exports.LiteralExpr = LiteralExpr;
class LogicalExpr {
    constructor(left, operator, right) {
        this.left = left;
        this.operator = operator;
        this.right = right;
    }
}
exports.LogicalExpr = LogicalExpr;
class SetExpr {
    constructor(object, name, value) {
        this.object = object;
        this.name = name;
        this.value = value;
    }
}
exports.SetExpr = SetExpr;
class SuperExpr {
    constructor(keyword, method) {
        this.keyword = keyword;
        this.method = method;
    }
}
exports.SuperExpr = SuperExpr;
class ThisExpr {
    constructor(keyword) {
        this.keyword = keyword;
    }
}
exports.ThisExpr = ThisExpr;
class TernaryExpr {
    constructor(cond, left, right) {
        this.cond = cond;
        this.left = left;
        this.right = right;
    }
}
exports.TernaryExpr = TernaryExpr;
class UnaryExpr {
    constructor(operator, right) {
        this.operator = operator;
        this.right = right;
    }
}
exports.UnaryExpr = UnaryExpr;
class VariableExpr {
    constructor(name) {
        this.name = name;
    }
}
exports.VariableExpr = VariableExpr;
class BlockStmt {
    constructor(statements) {
        this.statements = statements;
    }
}
exports.BlockStmt = BlockStmt;
class ClassStmt {
    constructor(name, superclass, methods) {
        this.name = name;
        this.superclass = superclass;
        this.methods = methods;
    }
}
exports.ClassStmt = ClassStmt;
class ExpressionStmt {
    constructor(expr) {
        this.expr = expr;
    }
}
exports.ExpressionStmt = ExpressionStmt;
class FunctionStmt {
    constructor(name, params, body) {
        this.name = name;
        this.params = params;
        this.body = body;
    }
}
exports.FunctionStmt = FunctionStmt;
class IfStmt {
    constructor(condition, thenBranch, elseBranch) {
        this.condition = condition;
        this.thenBranch = thenBranch;
        this.elseBranch = elseBranch;
    }
}
exports.IfStmt = IfStmt;
class PrintStmt {
    constructor(expr) {
        this.expr = expr;
    }
}
exports.PrintStmt = PrintStmt;
class ReturnStmt {
    constructor(keyword, value) {
        this.keyword = keyword;
        this.value = value;
    }
}
exports.ReturnStmt = ReturnStmt;
class WhileStmt {
    constructor(condition, body) {
        this.condition = condition;
        this.body = body;
    }
}
exports.WhileStmt = WhileStmt;
class ContinueStmt {
    constructor() { }
}
exports.ContinueStmt = ContinueStmt;
class BreakStmt {
    constructor() { }
}
exports.BreakStmt = BreakStmt;
class VarStmt {
    constructor(name, initializer) {
        this.name = name;
        this.initializer = initializer;
    }
}
exports.VarStmt = VarStmt;
